import React from 'react';
import { Search } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Hero = () => {
  return <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16 md:py-24" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <div className="max-w-3xl mx-auto text-center" data-id="element-21">
          <h1 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-22">
            Access Government Services Online
          </h1>
          <p className="text-xl mb-8 text-blue-100" data-id="element-23">
            Fast, secure, and convenient e-government services for citizens,
            businesses, and visitors
          </p>
          {/* Search bar */}
          <div className="relative max-w-2xl mx-auto mb-10" data-id="element-24">
            <input type="text" placeholder="Search for services..." className="w-full pl-12 pr-4 py-4 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300" data-id="element-25" />
            <Search className="absolute left-4 top-4 h-6 w-6 text-gray-500" data-id="element-26" />
            <button className="absolute right-2 top-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-27">
              Search
            </button>
          </div>
          {/* Quick access buttons */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto" data-id="element-28">
            <Link to="/services/citizens" className="bg-white bg-opacity-20 hover:bg-opacity-30 p-4 rounded-lg transition-all" data-id="element-29">
              <h3 className="font-semibold mb-1" data-id="element-30">Civil Registry</h3>
              <p className="text-sm text-blue-100" data-id="element-31">ID, certificates, etc.</p>
            </Link>
            <Link to="/services/business" className="bg-white bg-opacity-20 hover:bg-opacity-30 p-4 rounded-lg transition-all" data-id="element-32">
              <h3 className="font-semibold mb-1" data-id="element-33">Business</h3>
              <p className="text-sm text-blue-100" data-id="element-34">Registration, licenses</p>
            </Link>
            <Link to="/services/immigration" className="bg-white bg-opacity-20 hover:bg-opacity-30 p-4 rounded-lg transition-all" data-id="element-35">
              <h3 className="font-semibold mb-1" data-id="element-36">Immigration</h3>
              <p className="text-sm text-blue-100" data-id="element-37">Visa, passport, permits</p>
            </Link>
            <Link to="/services/payments" className="bg-white bg-opacity-20 hover:bg-opacity-30 p-4 rounded-lg transition-all" data-id="element-38">
              <h3 className="font-semibold mb-1" data-id="element-39">Payments</h3>
              <p className="text-sm text-blue-100" data-id="element-40">Taxes, fees, utilities</p>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};